import { render, staticRenderFns } from "./v_Admin_Actions.vue?vue&type=template&id=c2b8086a&scoped=true&"
import script from "./v_Admin_Actions.vue?vue&type=script&lang=js&"
export * from "./v_Admin_Actions.vue?vue&type=script&lang=js&"
import style0 from "./v_Admin_Actions.vue?vue&type=style&index=0&id=c2b8086a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8086a",
  null
  
)

export default component.exports